import { useContext, useState } from 'react';
import SearchContext from '@/context/SearchContext';

import { SearchInput } from './SearchInputField.styles';
const SearchInputField = () => {
  const { performSearch, searchInputDefaultValue, searchInputPlaceholder } =
    useContext(SearchContext);
  const [value, setValue] = useState(searchInputDefaultValue);

  const onChange = (event: { target: { value: string } }) => {
    const fieldValue = event.target.value;
    setValue(fieldValue);
    performSearch(fieldValue);
  };

  return (
    <SearchInput
      type="search"
      placeholder={searchInputPlaceholder}
      onChange={onChange}
      value={value}
    />
  );
};

export default SearchInputField;
